import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/app';
import CssBaseline from '@mui/material/CssBaseline';
//import reportWebVitals from './reportWebVitals';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-85598084-1');


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CssBaseline />
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
